import React, { Fragment } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import classes from '@nerdwallet/base-styles/classes';
import { Text, Link, Type } from '@nerdwallet/currency';
import { Impression as BedrockImpression } from '@nerdwallet/analytics/react/impression';

const CCBest = ({ eyebrow, heading, links }) => (
  <BedrockImpression entityName="hp_card_category_successful_display">
    <div className="cc-best__wrapper">
      <div
        className={classNames([
          'cc-best__content',
          classes('border-neutral-lighter'),
          classes('border-all-1'),
          classes('padding-vertical-4'),
          classes('padding-horizontal-4'),
          classes('display-flex'),
          classes('flex-direction-column'),
          classes('flex-direction-row--wide'),
        ])}
      >
        <div
          className={classNames([
            'cc-best-section__text',
            classes('margin-horizontal-auto'),
            classes('text-align-center'),
            classes('width-100'),
          ])}
        >
          <Type
            color="neutral-darker"
            uppercase
            size={1}
            bold
            className={classNames([
              'cc-best-section__eyebrow',
              classes('margin-bottom-3'),
            ])}
          >
            {eyebrow}
          </Type>
          <div
            className={classNames([
              'cc-best-section__heading',
              classes('margin-bottom-4'),
            ])}
          >
            <Text size="large" bold component="h2">
              {heading}
            </Text>
          </div>
          <Fragment>
            {links.map((link) => (
              <div className="cc-best__link" key={link.label}>
                <span className="cc-best__link-emoji">
                  {String.fromCodePoint(...link.emojiCodePoint)}
                </span>
                <Link href={link.href}>{link.label}</Link>
              </div>
            ))}
          </Fragment>
        </div>
      </div>
    </div>
  </BedrockImpression>
);

CCBest.propTypes = {
  eyebrow: PropTypes.string,
  heading: PropTypes.string,
  links: PropTypes.object,
};

CCBest.displayName = 'CCBest';

export default CCBest;
